'use strict';

var react = require('@emotion/react');

/**
 * A helper to visually hide elements while keeping them accessible to screen readers.
 */ const visuallyHidden = ()=>/*#__PURE__*/ react.css({
        position: "absolute",
        width: "1px",
        height: "1px",
        margin: "-1px",
        padding: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        border: 0,
        appearance: "none"
    }, "label:label-visuallyHiddenvisuallyHidden", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy91dGlscy9zdHlsZXMvdmlzdWFsbHlIaWRkZW4udHMiLCJzb3VyY2VzIjpbIi9idWlsZHMvZGV2ZWxvcGVycy9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvdXRpbHMvc3R5bGVzL3Zpc3VhbGx5SGlkZGVuLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuLyoqXG4gKiBBIGhlbHBlciB0byB2aXN1YWxseSBoaWRlIGVsZW1lbnRzIHdoaWxlIGtlZXBpbmcgdGhlbSBhY2Nlc3NpYmxlIHRvIHNjcmVlbiByZWFkZXJzLlxuICovXG5leHBvcnQgY29uc3QgdmlzdWFsbHlIaWRkZW4gPSAoKSA9PlxuICBjc3Moe1xuICAgIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gICAgd2lkdGg6IFwiMXB4XCIsXG4gICAgaGVpZ2h0OiBcIjFweFwiLFxuICAgIG1hcmdpbjogXCItMXB4XCIsXG4gICAgcGFkZGluZzogMCxcbiAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICAgIGJvcmRlcjogMCxcbiAgICBhcHBlYXJhbmNlOiBcIm5vbmVcIixcbiAgfSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS0UifQ== */");

exports.visuallyHidden = visuallyHidden;
//# sourceMappingURL=visuallyHidden.cjs.map
